import {
    aeWorkspaceElementsPanelMargin,
    smmWorkspaceElementsPanelMargin,
} from 'pages/components/constants'

export const showElementCardTitleInSingleLine = (
    title: string,
    nestingLevel?: number,
    elementType?: string
): boolean => {
    const thresholds: Record<
        number,
        { productType: number; default: number | null }
    > = {
        0: { productType: 46, default: 46 },
        1: { productType: 40, default: 40 },
        2: { productType: 20, default: 30 },
        3: { productType: 20, default: 25 },
        4: { productType: 20, default: null },
    }
    const config = thresholds[nestingLevel!]
    if (!config) return false
    const threshold =
        elementType === 'PRODUCTTYPE' ? config.productType : config.default
    return threshold !== null && title.length >= threshold
}
// This functions returns height or margin that needs to be removed from elements panel based on search bar displayed in AE/SMM/OM Elements Panel
export const elementsPanelSearchBarMargin = (
    isOMWorkspace?: boolean,
    isSMMWorkspace?: boolean
): number => {
    return isSMMWorkspace || isOMWorkspace
        ? smmWorkspaceElementsPanelMargin
        : aeWorkspaceElementsPanelMargin
}
